import React from 'react';
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid'
import { useFilterSidebar } from '../listLinlDraver/hooks/useFilterSidebar';
import { SLUGS } from 'src/enum/permissions.enum';

const SIDEBAR_MENU_CONFIG = [
  { id: 'estimate', to: '/est-menu', image: '/estimate.jpg', name: 'Смета' },
  { id: 'document', to: '/documents', image: '/material.jpg', name: 'Снабжение' },
  { id: 'production', to: '/prodmenu', image: '/orders.jpg', name: 'Производство' },
  { id: 'storage', to: '/storage', image: '/storage.jpg', name: 'Склад' },
  { id: 'analytics', to: '/analytics', image: '/analytics.jpg', name: 'Аналитика' },
  { id: 'settings', check: SLUGS.PROJECT.ROOT.UPDATE, to: '/settings', image: '/settings.jpg', name: 'Настройка' },
  { id: 'contractor', check: SLUGS.PROJECT.CONTRACTOR.LIST, to: '/contractor', image: '/orders.jpg', name: 'Подрядчики' },
]
function ProjectOne({ match }) {
  const accessibleSidebarItems = useFilterSidebar(SIDEBAR_MENU_CONFIG).map(e => ({
    to: match.url + e.to, image: process.env.PUBLIC_URL + e.image, name: e.name
  }));
  return (
    <Grid container>
      {accessibleSidebarItems.map((obj, index) => (obj) ?
        <Grid item key={index}>
          <ImgMediaCard {...obj} />
        </Grid>
        :
        null)
      }
    </Grid>
  )
}

export default ProjectOne;

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 120,
    margin: theme.spacing(1)
  },
  media: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'cover',
  },
}));

function ImgMediaCard({ image, name, to }) {
  const classes = useStyles();
  const toLink = React.forwardRef((props, ref) => (<Link ref={ref} to={to} {...props} />))
  return (
    <Card className={classes.card}>
      <CardActionArea component={toLink}>
        <CardMedia
          component="img"
          className={classes.media}
          height="80"
          width="80"
          image={image}
        />
        <CardContent>
          <Typography gutterBottom >
            {name}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

/*
function NewProjectMenu({ match}){

}

import React from 'react'
import Grid from '@mui/material/Grid'
import CardMenu from './source/CardMenu'

function CartProps({ arr, idProject, name }) {
  const str = (typeof idProject !== 'undefined') ? `/projects/${idProject}` : ''
  const arrNew = arr.map(obj =>
    check(obj.check) && { to: str + obj.to, primary: obj.primary, disabled: obj.disabled, add: obj.add }
  ).filter(key => typeof key !== 'boolean')
  return arrNew.length > 0 && <Grid item><CardMenu arr={arrNew} name={name} /></Grid>
}

function DocumentMenu(props) {
  const idProject = props.match.params.idProject
  const certificates = [
    { check: 'material:read', to: '/certificates', primary: 'Список ' },
  ]
  const menu = [
    { check: 'shipment:read', to: '/shipment/materials', primary: 'Покупка материалов', add: true },
    { check: 'shipment:read', to: '/receipt/materials', primary: 'Получение давальческих материалов', add: true },
    { check: 'shipment:read', to: '/shipment/order', primary: 'Заказать давальческие материалы' },
  ]
  return <Grid container>
    <CartProps arr={menu} idProject={idProject} name='Проект' />
  </Grid>
}
*/